/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_No_Commits_TitleInputs */

const en_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Commits`)
};

const fr_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun commit`)
};

const de_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Verpflichtungen`)
};

const it_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun impegno`)
};

const ru_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без обязательств`)
};

const es_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin compromisos`)
};

const zh_cn2_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有提交`)
};

const ja_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミットなし`)
};

const hi_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रतिबद्धता नहीं`)
};

const pt_pt2_team_share_no_commits_title = /** @type {(inputs: Team_Share_No_Commits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem commits`)
};

/**
* | output |
* | --- |
* | "No Commits" |
*
* @param {Team_Share_No_Commits_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_no_commits_title = /** @type {((inputs?: Team_Share_No_Commits_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_No_Commits_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_no_commits_title(inputs)
	if (locale === "de") return de_team_share_no_commits_title(inputs)
	if (locale === "it") return it_team_share_no_commits_title(inputs)
	if (locale === "ru") return ru_team_share_no_commits_title(inputs)
	if (locale === "es") return es_team_share_no_commits_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_no_commits_title(inputs)
	if (locale === "ja") return ja_team_share_no_commits_title(inputs)
	if (locale === "hi") return hi_team_share_no_commits_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_no_commits_title(inputs)
	return en_team_share_no_commits_title(inputs)
});